import { createSlice } from "@reduxjs/toolkit";
import { ALL_WORKGROUP_DEFAULT_FILTERS } from "../../util/constants";

const initialState = {
  employeeData: { isActive: false },
  stationFilter: "",
  workgroupFilters: ALL_WORKGROUP_DEFAULT_FILTERS,
};

export const userSessionSlice = createSlice({
  name: "userSession",
  initialState,
  reducers: {
    logIn: (state, action) => {
      state.employeeData.isActive = true;
      state.employeeData.appRole = action.payload.appRole;
      state.employeeData.defaultAppRole = action.payload.defaultAppRole;
      state.employeeData.eid = action.payload.eid;
      state.employeeData.firstName = action.payload.firstName;
      state.employeeData.lastName = action.payload.lastName;
      state.employeeData.isAdmin = action.payload.isAdmin;
      state.employeeData.multiStationAdminStationList = action.payload.multiStationAdminStationList;
      state.employeeData.isSuperuser = action.payload.isSuperuser;
      state.employeeData.superuserStationList = action.payload.superuserStationList;
      state.employeeData.jobCode = action.payload.jobCode;
      state.employeeData.kronosPersonNumber = action.payload.kronosPersonNumber;
      state.employeeData.activeStation = action.payload.activeStation;
      state.employeeData.homeStation = action.payload.homeStation;
      state.employeeData.isFTOrPT = action.payload.isFTOrPT;

      if (action.payload.tempStation) {
        state.employeeData.tempStation = action.payload.tempStation;
      }

      state.stationFilter = action.payload.activeStation;
      // state.workgroupFilters = action.payload.workgroupFilters;
    },
    updateStationFilter: (state, action) => {
      state.stationFilter = action.payload;
    },
    updateWorkgroupFilters: (state, action) => {
      state.workgroupFilters = action.payload;
    },
    clearUserState: (state) => initialState,
  },
});

export const { logIn, updateStationFilter, updateWorkgroupFilters, clearUserState } = userSessionSlice.actions;

export const selectUserSession = (state) => state.userSession.employeeData;

export const selectStationFilter = (state) => state.userSession.stationFilter;

export const selectWorkgroupFilters = (state) => state.userSession.workgroupFilters;

export default userSessionSlice.reducer;
